var _g, _path, _g2, _path2, _rect, _path3, _circle, _g3, _g4, _rect2, _path4, _circle2, _g5, _g6, _rect3, _path5, _rect4, _rect5, _rect6, _rect7, _circle3, _path6, _g7, _circle4, _rect8, _path7, _circle5, _g8, _g9, _path8, _line, _rect9, _path9, _rect0, _rect1, _rect10, _circle6, _path0, _g0, _circle7, _circle8, _path1, _path10, _path11, _path12, _path13, _g1, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZeroStateGraphEn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1653 1004",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dddddd_31_2310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M861.5 548V820C861.5 821.933 859.933 823.5 858 823.5H565C563.067 823.5 561.5 821.933 561.5 820V548C561.5 546.067 563.067 544.5 565 544.5H694.958C695.903 544.5 696.824 544.202 697.59 543.65L709.452 535.093C710.675 534.212 712.325 534.212 713.548 535.093L725.41 543.65C726.176 544.202 727.097 544.5 728.042 544.5H858C859.933 544.5 861.5 546.067 861.5 548Z",
    fill: "#23262D",
    stroke: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 585,
    y: 579,
    width: 21.1794,
    height: 20,
    rx: 10,
    fill: "#404648"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 616.428,
    y: 579,
    width: 79.9351,
    height: 20,
    rx: 10,
    fill: "#404648"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 707.294,
    y: 579,
    width: 56.7061,
    height: 20,
    rx: 10,
    fill: "#404648"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31_2310)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 585,
    y: 708,
    width: 46.2595,
    height: 20,
    rx: 10,
    fill: "#404648"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 646.68,
    y: 708,
    width: 140.321,
    height: 20,
    rx: 10,
    fill: "#404648"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 700.42,
    y: 766,
    width: 124.58,
    height: 20,
    rx: 10,
    fill: "#404648"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 585,
    y: 766,
    width: 100.763,
    height: 20,
    rx: 10,
    fill: "#404648"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 561,
    y: 622,
    width: 301,
    height: 60,
    fill: "#C4C4C4",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.954 663H585.735L593.416 641.182H598.295L605.987 663H601.768L595.941 645.656H595.771L589.954 663ZM590.092 654.445H601.598V657.62H590.092V654.445ZM614.265 663.288C612.979 663.288 611.829 662.957 610.813 662.297C609.798 661.636 608.995 660.678 608.406 659.42C607.816 658.163 607.521 656.636 607.521 654.839C607.521 653.021 607.82 651.487 608.416 650.237C609.02 648.98 609.833 648.032 610.856 647.393C611.879 646.746 613.018 646.423 614.276 646.423C615.234 646.423 616.023 646.587 616.641 646.913C617.259 647.233 617.749 647.62 618.111 648.075C618.473 648.522 618.754 648.945 618.952 649.342H619.112V641.182H622.979V663H619.187V660.422H618.952C618.754 660.82 618.466 661.242 618.089 661.69C617.713 662.13 617.216 662.506 616.598 662.819C615.98 663.131 615.202 663.288 614.265 663.288ZM615.341 660.124C616.158 660.124 616.854 659.903 617.429 659.463C618.004 659.016 618.441 658.394 618.739 657.599C619.038 656.803 619.187 655.876 619.187 654.818C619.187 653.76 619.038 652.84 618.739 652.059C618.448 651.278 618.015 650.67 617.44 650.237C616.871 649.804 616.172 649.587 615.341 649.587C614.482 649.587 613.764 649.811 613.189 650.259C612.614 650.706 612.18 651.324 611.889 652.112C611.598 652.901 611.452 653.803 611.452 654.818C611.452 655.841 611.598 656.754 611.889 657.556C612.188 658.352 612.624 658.98 613.2 659.442C613.782 659.896 614.496 660.124 615.341 660.124ZM633.161 663.288C631.876 663.288 630.725 662.957 629.71 662.297C628.694 661.636 627.892 660.678 627.302 659.42C626.713 658.163 626.418 656.636 626.418 654.839C626.418 653.021 626.716 651.487 627.313 650.237C627.916 648.98 628.73 648.032 629.752 647.393C630.775 646.746 631.915 646.423 633.172 646.423C634.131 646.423 634.919 646.587 635.537 646.913C636.155 647.233 636.645 647.62 637.007 648.075C637.369 648.522 637.65 648.945 637.849 649.342H638.009V641.182H641.876V663H638.083V660.422H637.849C637.65 660.82 637.362 661.242 636.986 661.69C636.61 662.13 636.112 662.506 635.494 662.819C634.877 663.131 634.099 663.288 633.161 663.288ZM634.237 660.124C635.054 660.124 635.75 659.903 636.325 659.463C636.901 659.016 637.338 658.394 637.636 657.599C637.934 656.803 638.083 655.876 638.083 654.818C638.083 653.76 637.934 652.84 637.636 652.059C637.345 651.278 636.911 650.67 636.336 650.237C635.768 649.804 635.068 649.587 634.237 649.587C633.378 649.587 632.661 649.811 632.085 650.259C631.51 650.706 631.077 651.324 630.786 652.112C630.494 652.901 630.349 653.803 630.349 654.818C630.349 655.841 630.494 656.754 630.786 657.556C631.084 658.352 631.521 658.98 632.096 659.442C632.678 659.896 633.392 660.124 634.237 660.124ZM661.598 646.636V649.619H652.191V646.636H661.598ZM654.513 642.716H658.37V658.078C658.37 658.597 658.448 658.994 658.604 659.271C658.768 659.541 658.981 659.726 659.244 659.825C659.506 659.925 659.798 659.974 660.117 659.974C660.359 659.974 660.579 659.957 660.778 659.921C660.984 659.886 661.14 659.854 661.246 659.825L661.896 662.84C661.69 662.911 661.396 662.989 661.012 663.075C660.636 663.16 660.174 663.21 659.627 663.224C658.661 663.252 657.791 663.107 657.017 662.787C656.243 662.46 655.629 661.956 655.174 661.274C654.727 660.592 654.506 659.74 654.513 658.717V642.716ZM671.785 663.32C670.187 663.32 668.802 662.968 667.631 662.265C666.459 661.562 665.55 660.578 664.903 659.314C664.264 658.05 663.944 656.572 663.944 654.882C663.944 653.192 664.264 651.711 664.903 650.44C665.55 649.168 666.459 648.181 667.631 647.478C668.802 646.775 670.187 646.423 671.785 646.423C673.383 646.423 674.768 646.775 675.94 647.478C677.112 648.181 678.018 649.168 678.657 650.44C679.303 651.711 679.626 653.192 679.626 654.882C679.626 656.572 679.303 658.05 678.657 659.314C678.018 660.578 677.112 661.562 675.94 662.265C674.768 662.968 673.383 663.32 671.785 663.32ZM671.807 660.23C672.673 660.23 673.398 659.992 673.98 659.516C674.562 659.033 674.996 658.387 675.28 657.577C675.571 656.768 675.716 655.866 675.716 654.871C675.716 653.87 675.571 652.964 675.28 652.155C674.996 651.338 674.562 650.688 673.98 650.205C673.398 649.722 672.673 649.481 671.807 649.481C670.919 649.481 670.18 649.722 669.591 650.205C669.008 650.688 668.572 651.338 668.28 652.155C667.996 652.964 667.854 653.87 667.854 654.871C667.854 655.866 667.996 656.768 668.28 657.577C668.572 658.387 669.008 659.033 669.591 659.516C670.18 659.992 670.919 660.23 671.807 660.23ZM690.341 663V646.636H694.027V649.417H694.219C694.56 648.479 695.124 647.748 695.913 647.222C696.701 646.69 697.642 646.423 698.736 646.423C699.844 646.423 700.778 646.693 701.538 647.233C702.305 647.766 702.844 648.494 703.157 649.417H703.327C703.69 648.508 704.3 647.783 705.16 647.244C706.026 646.697 707.053 646.423 708.239 646.423C709.744 646.423 710.973 646.899 711.925 647.851C712.876 648.803 713.352 650.191 713.352 652.016V663H709.485V652.613C709.485 651.597 709.215 650.855 708.675 650.386C708.136 649.911 707.475 649.673 706.694 649.673C705.763 649.673 705.036 649.964 704.51 650.546C703.991 651.121 703.732 651.871 703.732 652.794V663H699.95V652.453C699.95 651.608 699.695 650.933 699.183 650.429C698.679 649.925 698.018 649.673 697.202 649.673C696.648 649.673 696.143 649.815 695.689 650.099C695.234 650.376 694.872 650.77 694.602 651.281C694.332 651.786 694.197 652.375 694.197 653.05V663H690.341ZM717.265 663V646.636H721.121V663H717.265ZM719.204 644.314C718.593 644.314 718.067 644.112 717.627 643.707C717.187 643.295 716.966 642.801 716.966 642.226C716.966 641.643 717.187 641.15 717.627 640.745C718.067 640.333 718.593 640.127 719.204 640.127C719.822 640.127 720.347 640.333 720.78 640.745C721.221 641.15 721.441 641.643 721.441 642.226C721.441 642.801 721.221 643.295 720.78 643.707C720.347 644.112 719.822 644.314 719.204 644.314ZM728.24 646.636L731.543 652.677L734.899 646.636H738.979L734.047 654.818L739.064 663H735.005L731.543 657.109L728.113 663H724.022L729.007 654.818L724.15 646.636H728.24Z",
    fill: "#35FFD0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_31_2310",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 76,
    width: 751,
    height: 443
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 76H751L631 519H0V76Z",
    fill: "black"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_31_2310)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 75.7744,
    width: 391,
    height: 86,
    rx: 10,
    fill: "#2F2F30"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 118.774,
    r: 25,
    fill: "#49494B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 128.108C40 125.162 43.5817 122.774 48 122.774C52.4183 122.774 56 125.162 56 128.108",
    stroke: "#B3B3B3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0003 118.774C50.9458 118.774 53.3337 116.386 53.3337 113.441C53.3337 110.495 50.9458 108.107 48.0003 108.107C45.0548 108.107 42.667 110.495 42.667 113.441C42.667 116.386 45.0548 118.774 48.0003 118.774Z",
    stroke: "#B3B3B3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 392,
    cy: 118.774,
    r: 17,
    fill: "#2F2F30",
    stroke: "#181818",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_31_2310)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 108.774,
    width: 262,
    height: 20,
    rx: 10,
    fill: "#959598"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 508,
    y: 75.7744,
    width: 391,
    height: 86,
    rx: 10,
    fill: "#2F2F30"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 555,
    cy: 118.774,
    r: 25,
    fill: "#49494B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547 128.108C547 125.162 550.582 122.774 555 122.774C559.418 122.774 563 125.162 563 128.108",
    stroke: "#B3B3B3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555 118.774C557.946 118.774 560.334 116.386 560.334 113.441C560.334 110.495 557.946 108.107 555 108.107C552.055 108.107 549.667 110.495 549.667 113.441C549.667 116.386 552.055 118.774 555 118.774Z",
    stroke: "#B3B3B3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_31_2310)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 108.774,
    width: 60,
    height: 20,
    rx: 10,
    fill: "#959598"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 680,
    y: 108.774,
    width: 182,
    height: 20,
    rx: 10,
    fill: "#959598"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 508,
    y: 194.774,
    width: 391,
    height: 86,
    rx: 10,
    fill: "#2F2F30"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 555,
    cy: 237.774,
    r: 25,
    fill: "#49494B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547 247.108C547 244.162 550.582 241.774 555 241.774C559.418 241.774 563 244.162 563 247.108",
    stroke: "#B3B3B3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555 237.774C557.946 237.774 560.334 235.386 560.334 232.441C560.334 229.495 557.946 227.107 555 227.107C552.055 227.107 549.667 229.495 549.667 232.441C549.667 235.386 552.055 237.774 555 237.774Z",
    stroke: "#B3B3B3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_31_2310)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 227.774,
    width: 31,
    height: 20,
    rx: 10,
    fill: "#959598"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 646,
    y: 227.774,
    width: 117,
    height: 20,
    rx: 10,
    fill: "#959598"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 508,
    y: 313.774,
    width: 391,
    height: 86,
    rx: 10,
    fill: "#2F2F30"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 555,
    cy: 356.774,
    r: 25,
    fill: "#49494B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547 366.108C547 363.162 550.582 360.774 555 360.774C559.418 360.774 563 363.162 563 366.108",
    stroke: "#B3B3B3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555 356.774C557.946 356.774 560.334 354.386 560.334 351.441C560.334 348.495 557.946 346.107 555 346.107C552.055 346.107 549.667 348.495 549.667 351.441C549.667 354.386 552.055 356.774 555 356.774Z",
    stroke: "#B3B3B3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_31_2310)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 726,
    y: 346.774,
    width: 136,
    height: 20,
    rx: 10,
    fill: "#959598"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 346.774,
    width: 110,
    height: 20,
    rx: 10,
    fill: "#959598"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 508,
    y: 432.774,
    width: 391,
    height: 86,
    rx: 10,
    fill: "#2F2F30"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 555,
    cy: 475.774,
    r: 25,
    fill: "#49494B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547 485.108C547 482.162 550.582 479.774 555 479.774C559.418 479.774 563 482.162 563 485.108",
    stroke: "#B3B3B3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555 475.774C557.946 475.774 560.334 473.386 560.334 470.441C560.334 467.495 557.946 465.107 555 465.107C552.055 465.107 549.667 467.495 549.667 470.441C549.667 473.386 552.055 475.774 555 475.774Z",
    stroke: "#B3B3B3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_31_2310)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 465.774,
    width: 262,
    height: 20,
    rx: 10,
    fill: "#959598"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M509 237.774C448.535 238.523 450.117 117.77 392 118.491",
    stroke: "#2F2F30",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509 356.774C451.672 355.832 447.101 119.395 392 118.491",
    stroke: "#2F2F30",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513 475.774C456.635 473.224 446.176 120.94 392 118.491",
    stroke: "#2F2F30",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 396,
    y1: 118.774,
    x2: 508,
    y2: 118.774,
    stroke: "#2F2F30",
    strokeWidth: 6
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_31_2310",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 671,
    y: 76,
    width: 752,
    height: 443
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M791 76H1423V519H671L791 76Z",
    fill: "#C4C4C4"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_31_2310)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 546,
    y: 75.7744,
    width: 391,
    height: 147,
    rx: 10,
    fill: "#2F2F30"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M546 85.7744C546 80.2516 550.477 75.7744 556 75.7744H693V222.774H556C550.477 222.774 546 218.297 546 212.774V85.7744Z",
    fill: "#858585"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 937,
    cy: 149.774,
    r: 17,
    fill: "#2F2F30",
    stroke: "#181818",
    strokeWidth: 7
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_31_2310)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 718,
    y: 95.7744,
    width: 179,
    height: 20,
    rx: 10,
    fill: "#959598"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7_31_2310)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 718,
    y: 129.774,
    width: 21.1794,
    height: 20,
    rx: 10,
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 749.428,
    y: 129.774,
    width: 79.9351,
    height: 20,
    rx: 10,
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 840.294,
    y: 129.774,
    width: 56.7061,
    height: 20,
    rx: 10,
    fill: "#4A4A4A"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 546,
    y: 255.774,
    width: 391,
    height: 147,
    rx: 10,
    fill: "#2F2F30"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M546 265.774C546 260.252 550.477 255.774 556 255.774H693V402.774H556C550.477 402.774 546 398.297 546 392.774V265.774Z",
    fill: "#858585"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 937,
    cy: 329.774,
    r: 17,
    fill: "#2F2F30",
    stroke: "#181818",
    strokeWidth: 7
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8_31_2310)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 718,
    y: 275.774,
    width: 179,
    height: 20,
    rx: 10,
    fill: "#959598"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9_31_2310)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 804.084,
    y: 309.774,
    width: 92.916,
    height: 20,
    rx: 10,
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 718,
    y: 309.774,
    width: 75.1527,
    height: 20,
    rx: 10,
    fill: "#4A4A4A"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1061,
    y: 76,
    width: 391,
    height: 147,
    rx: 10,
    fill: "#2F2F30"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1061 86C1061 80.4772 1065.48 76 1071 76H1208V223H1071C1065.48 223 1061 218.523 1061 213V86Z",
    fill: "#525252"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1233,
    y: 96,
    width: 179,
    height: 20,
    rx: 10,
    fill: "#959598"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 1233,
    y: 130,
    width: 21.1794,
    height: 20,
    rx: 10,
    fill: "#4A4A4A"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 1264.43,
    y: 130,
    width: 79.9351,
    height: 20,
    rx: 10,
    fill: "#4A4A4A"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 1355.29,
    y: 130,
    width: 56.7061,
    height: 20,
    rx: 10,
    fill: "#4A4A4A"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1134.5,
    cy: 149.5,
    r: 27,
    stroke: "#999999",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_31_2310",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1113,
    y: 127,
    width: 22,
    height: 23
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1119.5 132.5L1113.5 140.5L1134.5 149.5L1133.5 127L1119.5 132.5Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_31_2310)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1134.5 166C1143.61 166 1151 158.613 1151 149.5C1151 140.387 1143.61 133 1134.5 133C1125.39 133 1118 140.387 1118 149.5C1118 158.613 1125.39 166 1134.5 166ZM1134.5 169C1145.27 169 1154 160.27 1154 149.5C1154 138.73 1145.27 130 1134.5 130C1123.73 130 1115 138.73 1115 149.5C1115 160.27 1123.73 169 1134.5 169Z",
    fill: "#999999"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1135,
    cy: 150,
    r: 4.5,
    stroke: "#999999",
    strokeWidth: 3
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 546,
    y: 435.774,
    width: 391,
    height: 147,
    rx: 10,
    fill: "#2F2F30"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M546 445.774C546 440.252 550.477 435.774 556 435.774H693V582.774H556C550.477 582.774 546 578.297 546 572.774V445.774Z",
    fill: "#858585"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 937,
    cy: 509.774,
    r: 17,
    fill: "#2F2F30",
    stroke: "#181818",
    strokeWidth: 7
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip10_31_2310)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 718,
    y: 455.774,
    width: 179,
    height: 20,
    rx: 10,
    fill: "#959598"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip11_31_2310)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 718,
    y: 489.774,
    width: 21.1794,
    height: 20,
    rx: 10,
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 749.428,
    y: 489.774,
    width: 79.9351,
    height: 20,
    rx: 10,
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 840.294,
    y: 489.774,
    width: 56.7061,
    height: 20,
    rx: 10,
    fill: "#4A4A4A"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1061 334.527C1003.67 333.585 999.101 153.148 944 152.244",
    stroke: "#2F2F30",
    strokeWidth: 6
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 948,
    y1: 149,
    x2: 1060,
    y2: 149,
    stroke: "#2F2F30",
    strokeWidth: 6
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 1061,
    y: 256,
    width: 391,
    height: 147,
    rx: 10,
    fill: "#2F2F30"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1061 266C1061 260.477 1065.48 256 1071 256H1208V403H1071C1065.48 403 1061 398.523 1061 393V266Z",
    fill: "#525252"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 1233,
    y: 276,
    width: 179,
    height: 20,
    rx: 10,
    fill: "#959598"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 1319.08,
    y: 310,
    width: 92.916,
    height: 20,
    rx: 10,
    fill: "#4A4A4A"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 1233,
    y: 310,
    width: 75.1527,
    height: 20,
    rx: 10,
    fill: "#4A4A4A"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1134.5,
    cy: 329.5,
    r: 27,
    stroke: "#999999",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_31_2310",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1113,
    y: 307,
    width: 22,
    height: 23
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M1119.5 312.5L1113.5 320.5L1134.5 329.5L1133.5 307L1119.5 312.5Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_31_2310)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1134.5 346C1143.61 346 1151 338.613 1151 329.5C1151 320.387 1143.61 313 1134.5 313C1125.39 313 1118 320.387 1118 329.5C1118 338.613 1125.39 346 1134.5 346ZM1134.5 349C1145.27 349 1154 340.27 1154 329.5C1154 318.73 1145.27 310 1134.5 310C1123.73 310 1115 318.73 1115 329.5C1115 340.27 1123.73 349 1134.5 349Z",
    fill: "#999999"
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 1135,
    cy: 330,
    r: 4.5,
    stroke: "#999999",
    strokeWidth: 3
  }))), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 1423,
    cy: 76,
    r: 76,
    fill: "#036551"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M1437.69 100.325C1436.26 100.325 1435.1 99.1654 1435.1 97.7317V44.3749C1435.1 43.5821 1435.46 42.8323 1436.08 42.341C1436.7 41.8496 1437.51 41.6672 1438.29 41.8496C1440.39 42.346 1458.81 46.9889 1458.81 57.3918C1458.81 61.1659 1457.78 64.0155 1455.74 65.8595C1453.27 68.0961 1450.34 67.8782 1450.02 67.8403C1448.6 67.6959 1447.56 66.4269 1447.7 65.0008C1447.84 63.5773 1449.12 62.5666 1450.54 62.6781C1450.53 62.6755 1451.52 62.7186 1452.31 61.9714C1453.17 61.1532 1453.62 59.5701 1453.62 57.3918C1453.62 53.2732 1445.98 49.6511 1440.29 47.8045V97.7317C1440.29 99.1654 1439.12 100.325 1437.69 100.325Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1428.8 109.219C1422.47 109.219 1417.31 104.067 1417.31 97.7321C1417.31 91.3972 1422.47 86.2451 1428.8 86.2451C1435.13 86.2451 1440.29 91.3972 1440.29 97.7321C1440.29 104.067 1435.13 109.219 1428.8 109.219ZM1428.8 91.4326C1425.33 91.4326 1422.5 94.2594 1422.5 97.7321C1422.5 101.205 1425.33 104.032 1428.8 104.032C1432.27 104.032 1435.1 101.205 1435.1 97.7321C1435.1 94.2594 1432.27 91.4326 1428.8 91.4326Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1422.5 70.5908H1388.78C1387.35 70.5908 1386.19 69.4307 1386.19 67.9971C1386.19 66.5634 1387.35 65.4033 1388.78 65.4033H1422.5C1423.93 65.4033 1425.09 66.5634 1425.09 67.9971C1425.09 69.4307 1423.93 70.5908 1422.5 70.5908Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1414.74 85.5967H1388.78C1387.35 85.5967 1386.19 84.4366 1386.19 83.0029C1386.19 81.5693 1387.35 80.4092 1388.78 80.4092H1414.74C1416.17 80.4092 1417.33 81.5693 1417.33 83.0029C1417.33 84.4366 1416.17 85.5967 1414.74 85.5967Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1409.41 101.437H1388.78C1387.35 101.437 1386.19 100.277 1386.19 98.8437C1386.19 97.4101 1387.35 96.25 1388.78 96.25H1409.41C1410.84 96.25 1412 97.4101 1412 98.8437C1412 100.277 1410.84 101.437 1409.41 101.437Z",
    fill: "white"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dddddd_31_2310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1572.5 175V447C1572.5 448.933 1570.93 450.5 1569 450.5H1276C1274.07 450.5 1272.5 448.933 1272.5 447V175C1272.5 173.067 1274.07 171.5 1276 171.5H1405.96C1406.9 171.5 1407.82 171.202 1408.59 170.65L1420.45 162.093C1421.68 161.212 1423.32 161.212 1424.55 162.093L1436.41 170.65C1437.18 171.202 1438.1 171.5 1439.04 171.5H1569C1570.93 171.5 1572.5 173.067 1572.5 175Z",
    fill: "#23262D",
    stroke: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1296,
    y: 206,
    width: 21.1794,
    height: 20,
    rx: 10,
    fill: "#404648"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1327.43,
    y: 206,
    width: 79.9351,
    height: 20,
    rx: 10,
    fill: "#404648"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1418.29,
    y: 206,
    width: 56.7061,
    height: 20,
    rx: 10,
    fill: "#404648"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip12_31_2310)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1296,
    y: 335,
    width: 46.2595,
    height: 20,
    rx: 10,
    fill: "#404648"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1357.68,
    y: 335,
    width: 140.321,
    height: 20,
    rx: 10,
    fill: "#404648"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1411.42,
    y: 393,
    width: 124.58,
    height: 20,
    rx: 10,
    fill: "#404648"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1296,
    y: 393,
    width: 100.763,
    height: 20,
    rx: 10,
    fill: "#404648"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1272,
    y: 249,
    width: 301,
    height: 60,
    fill: "#C4C4C4",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1300.95 290H1296.74L1304.42 268.182H1309.3L1316.99 290H1312.77L1306.94 272.656H1306.77L1300.95 290ZM1301.09 281.445H1312.6V284.62H1301.09V281.445ZM1325.26 290.288C1323.98 290.288 1322.83 289.957 1321.81 289.297C1320.8 288.636 1320 287.678 1319.41 286.42C1318.82 285.163 1318.52 283.636 1318.52 281.839C1318.52 280.021 1318.82 278.487 1319.42 277.237C1320.02 275.98 1320.83 275.032 1321.86 274.393C1322.88 273.746 1324.02 273.423 1325.28 273.423C1326.23 273.423 1327.02 273.587 1327.64 273.913C1328.26 274.233 1328.75 274.62 1329.11 275.075C1329.47 275.522 1329.75 275.945 1329.95 276.342H1330.11V268.182H1333.98V290H1330.19V287.422H1329.95C1329.75 287.82 1329.47 288.242 1329.09 288.69C1328.71 289.13 1328.22 289.506 1327.6 289.819C1326.98 290.131 1326.2 290.288 1325.26 290.288ZM1326.34 287.124C1327.16 287.124 1327.85 286.903 1328.43 286.463C1329 286.016 1329.44 285.394 1329.74 284.599C1330.04 283.803 1330.19 282.876 1330.19 281.818C1330.19 280.76 1330.04 279.84 1329.74 279.059C1329.45 278.278 1329.01 277.67 1328.44 277.237C1327.87 276.804 1327.17 276.587 1326.34 276.587C1325.48 276.587 1324.76 276.811 1324.19 277.259C1323.61 277.706 1323.18 278.324 1322.89 279.112C1322.6 279.901 1322.45 280.803 1322.45 281.818C1322.45 282.841 1322.6 283.754 1322.89 284.556C1323.19 285.352 1323.62 285.98 1324.2 286.442C1324.78 286.896 1325.5 287.124 1326.34 287.124ZM1344.16 290.288C1342.88 290.288 1341.73 289.957 1340.71 289.297C1339.69 288.636 1338.89 287.678 1338.3 286.42C1337.71 285.163 1337.42 283.636 1337.42 281.839C1337.42 280.021 1337.72 278.487 1338.31 277.237C1338.92 275.98 1339.73 275.032 1340.75 274.393C1341.78 273.746 1342.91 273.423 1344.17 273.423C1345.13 273.423 1345.92 273.587 1346.54 273.913C1347.16 274.233 1347.65 274.62 1348.01 275.075C1348.37 275.522 1348.65 275.945 1348.85 276.342H1349.01V268.182H1352.88V290H1349.08V287.422H1348.85C1348.65 287.82 1348.36 288.242 1347.99 288.69C1347.61 289.13 1347.11 289.506 1346.49 289.819C1345.88 290.131 1345.1 290.288 1344.16 290.288ZM1345.24 287.124C1346.05 287.124 1346.75 286.903 1347.33 286.463C1347.9 286.016 1348.34 285.394 1348.64 284.599C1348.93 283.803 1349.08 282.876 1349.08 281.818C1349.08 280.76 1348.93 279.84 1348.64 279.059C1348.34 278.278 1347.91 277.67 1347.34 277.237C1346.77 276.804 1346.07 276.587 1345.24 276.587C1344.38 276.587 1343.66 276.811 1343.09 277.259C1342.51 277.706 1342.08 278.324 1341.79 279.112C1341.49 279.901 1341.35 280.803 1341.35 281.818C1341.35 282.841 1341.49 283.754 1341.79 284.556C1342.08 285.352 1342.52 285.98 1343.1 286.442C1343.68 286.896 1344.39 287.124 1345.24 287.124ZM1372.6 273.636V276.619H1363.19V273.636H1372.6ZM1365.51 269.716H1369.37V285.078C1369.37 285.597 1369.45 285.994 1369.6 286.271C1369.77 286.541 1369.98 286.726 1370.24 286.825C1370.51 286.925 1370.8 286.974 1371.12 286.974C1371.36 286.974 1371.58 286.957 1371.78 286.921C1371.98 286.886 1372.14 286.854 1372.25 286.825L1372.9 289.84C1372.69 289.911 1372.4 289.989 1372.01 290.075C1371.64 290.16 1371.17 290.21 1370.63 290.224C1369.66 290.252 1368.79 290.107 1368.02 289.787C1367.24 289.46 1366.63 288.956 1366.17 288.274C1365.73 287.592 1365.51 286.74 1365.51 285.717V269.716ZM1382.79 290.32C1381.19 290.32 1379.8 289.968 1378.63 289.265C1377.46 288.562 1376.55 287.578 1375.9 286.314C1375.26 285.05 1374.94 283.572 1374.94 281.882C1374.94 280.192 1375.26 278.711 1375.9 277.44C1376.55 276.168 1377.46 275.181 1378.63 274.478C1379.8 273.775 1381.19 273.423 1382.79 273.423C1384.38 273.423 1385.77 273.775 1386.94 274.478C1388.11 275.181 1389.02 276.168 1389.66 277.44C1390.3 278.711 1390.63 280.192 1390.63 281.882C1390.63 283.572 1390.3 285.05 1389.66 286.314C1389.02 287.578 1388.11 288.562 1386.94 289.265C1385.77 289.968 1384.38 290.32 1382.79 290.32ZM1382.81 287.23C1383.67 287.23 1384.4 286.992 1384.98 286.516C1385.56 286.033 1386 285.387 1386.28 284.577C1386.57 283.768 1386.72 282.866 1386.72 281.871C1386.72 280.87 1386.57 279.964 1386.28 279.155C1386 278.338 1385.56 277.688 1384.98 277.205C1384.4 276.722 1383.67 276.481 1382.81 276.481C1381.92 276.481 1381.18 276.722 1380.59 277.205C1380.01 277.688 1379.57 278.338 1379.28 279.155C1379 279.964 1378.85 280.87 1378.85 281.871C1378.85 282.866 1379 283.768 1379.28 284.577C1379.57 285.387 1380.01 286.033 1380.59 286.516C1381.18 286.992 1381.92 287.23 1382.81 287.23ZM1401.34 290V273.636H1405.03V276.417H1405.22C1405.56 275.479 1406.12 274.748 1406.91 274.222C1407.7 273.69 1408.64 273.423 1409.74 273.423C1410.84 273.423 1411.78 273.693 1412.54 274.233C1413.3 274.766 1413.84 275.494 1414.16 276.417H1414.33C1414.69 275.508 1415.3 274.783 1416.16 274.244C1417.03 273.697 1418.05 273.423 1419.24 273.423C1420.74 273.423 1421.97 273.899 1422.92 274.851C1423.88 275.803 1424.35 277.191 1424.35 279.016V290H1420.49V279.613C1420.49 278.597 1420.22 277.855 1419.68 277.386C1419.14 276.911 1418.48 276.673 1417.69 276.673C1416.76 276.673 1416.04 276.964 1415.51 277.546C1414.99 278.121 1414.73 278.871 1414.73 279.794V290H1410.95V279.453C1410.95 278.608 1410.69 277.933 1410.18 277.429C1409.68 276.925 1409.02 276.673 1408.2 276.673C1407.65 276.673 1407.14 276.815 1406.69 277.099C1406.23 277.376 1405.87 277.77 1405.6 278.281C1405.33 278.786 1405.2 279.375 1405.2 280.05V290H1401.34ZM1428.26 290V273.636H1432.12V290H1428.26ZM1430.2 271.314C1429.59 271.314 1429.07 271.112 1428.63 270.707C1428.19 270.295 1427.97 269.801 1427.97 269.226C1427.97 268.643 1428.19 268.15 1428.63 267.745C1429.07 267.333 1429.59 267.127 1430.2 267.127C1430.82 267.127 1431.35 267.333 1431.78 267.745C1432.22 268.15 1432.44 268.643 1432.44 269.226C1432.44 269.801 1432.22 270.295 1431.78 270.707C1431.35 271.112 1430.82 271.314 1430.2 271.314ZM1439.24 273.636L1442.54 279.677L1445.9 273.636H1449.98L1445.05 281.818L1450.06 290H1446.01L1442.54 284.109L1439.11 290H1435.02L1440.01 281.818L1435.15 273.636H1439.24Z",
    fill: "#35FFD0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddddd_31_2310",
    x: 481,
    y: 533,
    width: 461,
    height: 471,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.76726
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.1069
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0196802 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_31_2310"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.6501
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.66004
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0282725 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_31_2310",
    result: "effect2_dropShadow_31_2310"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12.5216
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.00862
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.035 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_31_2310",
    result: "effect3_dropShadow_31_2310"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 22.3363
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.93452
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0417275 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_31_2310",
    result: "effect4_dropShadow_31_2310"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 41.7776
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.711
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0503198 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_31_2310",
    result: "effect5_dropShadow_31_2310"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 100
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_dropShadow_31_2310",
    result: "effect6_dropShadow_31_2310"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_31_2310",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dddddd_31_2310",
    x: 1192,
    y: 160,
    width: 461,
    height: 471,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.76726
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.1069
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0196802 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_31_2310"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.6501
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.66004
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0282725 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_31_2310",
    result: "effect2_dropShadow_31_2310"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12.5216
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.00862
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.035 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_31_2310",
    result: "effect3_dropShadow_31_2310"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 22.3363
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.93452
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0417275 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_31_2310",
    result: "effect4_dropShadow_31_2310"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 41.7776
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.711
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0503198 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_31_2310",
    result: "effect5_dropShadow_31_2310"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 100
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_dropShadow_31_2310",
    result: "effect6_dropShadow_31_2310"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_31_2310",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31_2310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 202,
    height: 20,
    fill: "white",
    transform: "translate(585 708)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_31_2310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 262,
    height: 20,
    fill: "white",
    transform: "translate(93 108.774)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_31_2310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 262,
    height: 20,
    fill: "white",
    transform: "translate(600 108.774)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_31_2310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 262,
    height: 20,
    fill: "white",
    transform: "translate(600 227.774)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_31_2310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 262,
    height: 20,
    fill: "white",
    transform: "translate(600 346.774)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_31_2310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 262,
    height: 20,
    fill: "white",
    transform: "translate(600 465.774)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_31_2310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 179,
    height: 20,
    fill: "white",
    transform: "translate(718 95.7744)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7_31_2310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 179,
    height: 20,
    fill: "white",
    transform: "translate(718 129.774)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8_31_2310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 179,
    height: 20,
    fill: "white",
    transform: "translate(718 275.774)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9_31_2310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 179,
    height: 20,
    fill: "white",
    transform: "translate(718 309.774)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10_31_2310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 179,
    height: 20,
    fill: "white",
    transform: "translate(718 455.774)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11_31_2310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 179,
    height: 20,
    fill: "white",
    transform: "translate(718 489.774)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip12_31_2310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 202,
    height: 20,
    fill: "white",
    transform: "translate(1296 335)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeroStateGraphEn);
export default __webpack_public_path__ + "static/media/zeroState-graph-en.a9e25a2d.svg";
export { ForwardRef as ReactComponent };